import React from 'react';

const FloatingLabelInput = ({
  label,
  name,
  id,
  type = 'text',
  value,
  onChange,
  placeholder = '',
  required = false,
  autocomplete = 'off',
  className = '',
  
}) => {
  return (
    <div className={`relative w-full ${className}`}>
      <input
        type={type}
        name={name}
        id={id}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        required={required}
        autoComplete={autocomplete}
        className={`peer h-9 w-full border border-gray-300 rounded-md px-3 placeholder-transparent focus:outline-none focus:ring-blue-500 focus:border-blue-500 ${className}`}
      />
      <label
        htmlFor={id}
        className="absolute left-3 -top-3.5 bg-white px-1 text-sm floating_textbox_label_lineheight text-gray-500 transition-all 
          peer-placeholder-shown:top-2.5 
          peer-focus:-top-3.5 peer-focus:text-sm peer-focus:text-blue-500"
      >
        {label}
      </label>
    </div>
  );
};

export default FloatingLabelInput;
